
import InstructorResetPassword from "../components/forgotPassword/InstructorResetPassword";
import InstructorNavbar from "../components/instructor/InstructorNavbar";
// import Navbar from "../components/layout/Navbar";


const InstructorResetPasswordPage = () => {
    return ( 
        <>
        <InstructorNavbar/>
        <InstructorResetPassword/>
        </>
     );
}
 
export default InstructorResetPasswordPage;